import type { IGuestbookMessageResponse } from "@/types"

export enum GuestbookMessageType {
  Unknown,
  Text,
  Video,
}

export class GuestbookMessage {
  public id?: number
  public albumId?: number
  public type: GuestbookMessageType = GuestbookMessageType.Unknown
  public fromName: string
  public fromEmail?: string
  public message?: string
  public videoUrl?: string
  public snapshotUrl?: string
  public isCreator?: boolean = false
  public createdAt?: Date

  constructor(message: Partial<GuestbookMessage>) {
    this.id = message.id
    this.albumId = message.albumId
    this.type = message.type ?? GuestbookMessageType.Unknown
    this.fromName = message.fromName ?? "Unknown Guest"
    this.fromEmail = message.fromEmail
    this.message = message.message
    this.videoUrl = message.videoUrl
    this.snapshotUrl = message.snapshotUrl
    this.isCreator = message.isCreator ?? false
    this.createdAt = message.createdAt
  }

  public static fromResponse(response: IGuestbookMessageResponse) {
    let type = GuestbookMessageType.Unknown

    switch (response.Type) {
      case 0:
        type = GuestbookMessageType.Text
        break
      case 1:
        type = GuestbookMessageType.Video
        break
      default:
        type = GuestbookMessageType.Unknown
        break
    }

    const createdAt = response?.DateCreated ? new Date(response?.DateCreated) : undefined

    return new GuestbookMessage({
      id: response?.Id,
      albumId: response?.Album,
      type,
      fromName: response?.FromName,
      fromEmail: response?.FromEmail,
      message: response?.Message,
      videoUrl: response?.VideoUrl,
      snapshotUrl: response?.SnapshotUrl,
      isCreator: response?.IsCreator,
      createdAt,
    })
  }
}
